<header class="privacy-policy-header">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <app-navbar></app-navbar>
      </div>
      <div class="col-12 d-flex flex-column align-items-center">
        <h1 class="title">{{ "PRIVACY_POLICY_TITLE" | translate }}</h1>
        <div class="breadcramb">
          <a class="main" routerLink="/home">{{ "HOME" | translate }}</a> / <span class="sub">{{"PRIVACY_POLICY_TITLE" |
            translate}}</span>
        </div>
      </div>
    </div>
  </div>
</header>

<section class="privacy-policy-content">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <p class="regular-text">
          {{ "PRIVACY_POLICY_CONTENT1" | translate }}
          <span class="bolded-underline">
            <a routerLink="/home">
              {{ 'libya.hidaya.me' }}
            </a>
          </span>
        </p>
        <p class="regular-text">{{ "PRIVACY_POLICY_CONTENT2" | translate }}</p>
      </div>

      <div class="col-12 pt-70">
        <p class="section-title">{{ "PRIVACY_POLICY_SECTION1" | translate }}</p>
        <ul>
          <li>
            <p class="regular-text">{{ "PRIVACY_POLICY_REASON1" | translate }}</p> <br>
            <p class="regular-text" *ngIf="this.translate.currentLang == 'en'">{{"PRIVACY_POLICY_REASON1_1" |
              translate}}</p>
          </li>

          <li>
            <p class="regular-text">{{ "PRIVACY_POLICY_REASON2" | translate }}</p> <br>
            <p class="regular-text" *ngIf="this.translate.currentLang == 'en'">{{"PRIVACY_POLICY_REASON2_1" |
              translate}}</p>
          </li>

          <li>
            <p class="regular-text">{{ "PRIVACY_POLICY_REASON3" | translate }}</p> <br>
            <p class="regular-text" *ngIf="this.translate.currentLang == 'en'">{{"PRIVACY_POLICY_REASON3_1" |
              translate}}</p>
          </li>

          <li>
            <span class="bolded">{{ "PRIVACY_POLICY_REASON4" | translate }}</span> <br>
            <p class="regular-text">{{ "PRIVACY_POLICY_REASON5" | translate }}</p>
          </li>

          <li>
            <span class="bolded">{{ "PRIVACY_POLICY_REASON6" | translate }}</span> <br>
            <p class="regular-text">{{ "PRIVACY_POLICY_REASON7" | translate }}</p>
          </li>
        </ul>
      </div>

      <div class="col-12 pt-70">
        <p class="section-title">{{ "PRIVACY_POLICY_SECTION2" | translate }}</p>
        <p class="regular-text">{{ "PRIVACY_POLICY_SECTION2_NOTE" | translate }}</p>
        <ul class="ul-row">
          <li>
            <p class="regular-text">{{ "PRIVACY_POLICY_PERSONAL1" | translate }}</p>
          </li>

          <li>
            <p class="regular-text">{{ "PRIVACY_POLICY_PERSONAL2" | translate }}</p>
          </li>

          <li>
            <p class="regular-text">{{ "PRIVACY_POLICY_PERSONAL3" | translate }}</p>
          </li>

          <li>
            <p class="regular-text">{{ "PRIVACY_POLICY_PERSONAL4" | translate }}</p>
          </li>

          <li>
            <p class="regular-text">{{ "PRIVACY_POLICY_PERSONAL5" | translate }}</p>
          </li>

          <li>
            <p class="regular-text">{{ "PRIVACY_POLICY_PERSONAL6" | translate }}</p>
          </li>
        </ul>
      </div>

      <div class="col-12 pt-70">
        <p class="section-title">{{ "PRIVACY_POLICY_SECTION3" | translate }}</p>
        <p class="regular-text">{{ "PRIVACY_POLICY_SECTION3_NOTE" | translate }}</p>
      </div>

      <div class="col-12 pt-70">
        <p class="section-title">{{ "PRIVACY_POLICY_SECTION4" | translate }}</p>
        <p class="regular-text">{{ "PRIVACY_POLICY_SECTION4_NOTE" | translate }}</p>
        <ul>
          <li>
            <p class="regular-text">{{ "PRIVACY_POLICY_SECTION4_point1" | translate }}</p>
          </li>
        </ul>
        <p class="regular-text">{{ "PRIVACY_POLICY_SECTION4_point2" | translate }}</p>
      </div>

      <div class="col-12 pt-70">
        <p class="regular-text">{{ "PRIVACY_POLICY_SECTION5_NOTE" | translate }}</p>

        <p class="regular-text">{{ "PRIVACY_POLICY_SECTION5_NOTE_2" | translate }}
          <span class="bolded-underline">{{ 'info@hidaya.me' }}</span>
        </p>
      </div>
    </div>
  </div>
</section>
